import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { FormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'preparation-hours',
  standalone: true,
  imports: [
    MatFormFieldModule,
    FormsModule,
    MatButtonModule,
    MatInputModule,
    MatDialogModule
  ],
  templateUrl: './preparation-hours.component.html',
  styleUrl: './preparation-hours.component.scss'
})
export class PreparationHoursComponent {
  prepTimeValue: string = '20 Minutes';
  prepTimeValueInt: number = 20;

  constructor(
    public dialogRef: MatDialogRef<PreparationHoursComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { prepTimeValue: string; prepTimeValueInt: number }
  )
  {
    if (data && data.prepTimeValue) {
      this.prepTimeValue = data.prepTimeValue;
      this.prepTimeValueInt = data.prepTimeValueInt;
    }
  }

  savePrepTime() {
    if (this.prepTimeValueInt && this.prepTimeValueInt > 0 && Number.isInteger(this.prepTimeValueInt)) {
      this.prepTimeValue = `${this.prepTimeValueInt} Minutes`;
      this.dialogRef.close({ prepTimeValue: this.prepTimeValue, prepTimeValueInt: this.prepTimeValueInt });
    }
  }

  discard() {
    this.dialogRef.close();
  }
}
